export default "__VITE_ASSET__e61df418__"